<div
  [class.hide-after-content]="hideAfterContent"
  class="w-full notification-sidebar-container md:w-[301px] md:ml-8 rounded-xl"
  [@fadeInOut]
>
  <div
    #scrollableContent
    [ngClass]="{ 'scrollable-content': (notifications$ | async).length > 0 }"
    class="p-6 h-full"
    (scroll)="onScroll($event)"
  >
    <div class="flex justify-between items-center mb-6">
      <!-- Title -->
      <h1 class="">
        {{ 'notification-dashboard.title' | translate }}
      </h1>
      <!-- Create notification button -->
      <rk-button
        [icon]="'plus'"
        [variant]="'secondary'"
        [iconOnly]="true"
        (buttonClick)="openForm('ButtonSendNotification')"
      ></rk-button>
    </div>
    <!-- Empty state -->
    @if ((notifications$ | async).length === 0 && (isLoading$ | async) === false) {
      <div
        class="flex flex-col justify-center items-center w-full h-full rounded-xl bg-white pb-4"
      >
        <h1 class="text-[24px] text-center font-bold">
          {{ 'notification-sidebar.empty-state.title' | translate: { count: 0 } }}
        </h1>
        <p class="text-[16px] opacity-70 text-center mt-2">
          {{ 'notification-sidebar.empty-state.desc' | translate }}
        </p>
        <rk-button
          [@quickFadeInOut]
          class="mt-7"
          (buttonClick)="openForm('ButtonSendNotificationEmptyState')"
          [text]="'notification-dashboard.send' | translate"
        ></rk-button>
      </div>
    }
    <!-- List -->
    @for (notification of notifications$ | async; track notification) {
      <ul class="flex w-full flex-1">
        <!-- List item -->
        <li [class.waiting]="notification.waiting" class="mb-3 p-6">
          @if (!notification.waiting) {
            <div class="flex text-xs">
              <fa-icon [icon]="'clock'" class="opacity-30"></fa-icon>
              <!-- Date -->
              <span class="opacity-50 ml-1">
                {{ formatDate(notification.sendAt) }}
              </span>
              <!-- Total sent -->
              <fa-icon [icon]="'paper-plane'" class="opacity-30 ml-2"></fa-icon>
              <span class="opacity-50 ml-1">{{ getTotalSent(notification) || '-' }}</span>
            </div>
          }
          <!-- Scheduled / Draft tag -->
          @if (notification.waiting) {
            <div>
              <div
                class="scheduled-draft-tag px-2 py-1 text-white w-fit flex items-center"
              >
                <fa-icon
                  class="mr-1 text-[10px]"
                  [icon]="notification.enabled ? 'calendar-alt' : 'pen'"
                ></fa-icon>
                <span class="text-xs leading-none">
                  {{
                    notification.enabled
                      ? ('notification-sidebar.scheduled' | translate)
                      : ('notification-table.draft' | translate)
                  }}
                </span>
              </div>
            </div>
          }
          <!-- Message -->
          <div class="notification-message text-base font-medium">
            {{ notification.message }}
          </div>
        </li>
      </ul>
    }
  </div>
</div>
